import React, { useState } from "react";
import ContainerPop from "../../Pops/ContainerPop";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { successToaster } from "../../../helper/toasterConfiguration";
import ButtonClose from "../../Pops/ButtonClose";
import { CircularProgress } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";

const DeleteModal = ({ show, handleClose, selectedId, setShouldRefresh }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const { result, response, message } = await Helper.Get({
        url: `${api_Routes.Smmticket.SendTickets}${selectedId}`,
      });
      if (response) {
        successToaster("Category successfully deleted");
        handleClose();
        setShouldRefresh(true);
      }
    } catch (error) {
      console.error("An error occurred during deletion:", error);
      // Optional: Display user-facing error notification
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`fixed inset-0 !z-50 ${
        show ? "visible" : "hidden"
      } bg-black bg-opacity-50 flex justify-center items-center`}
      onClick={handleClose} // This will close the modal when clicking outside
    >
      <ContainerPop>
        <div
          aria-label="pop delete"
          className="swals-show flex justify-center relative box-border flex-col z-50 w-[32em] max-w-full p-4 border-0 rounded-sm bg-secondary dark:bg-darkPrimary text-darkTextColor dark:text-darkTextColor m-auto"
          onClick={(e) => e.stopPropagation()} // Prevent click from propagating
        >
          <div aria-label="header" className="text-[1rem]">
            <div
              className="close absolute top-6 right-4 z-50 !cursor-pointer text-textColor dark:text-darkTextColor"
              onClick={handleClose}
            >
              <IoMdCloseCircleOutline size={"1.3rem"} />{" "}
            </div>
            <div className="flex items-center justify-center w-[5em] h-[5em] mt-[1.25em] mx-auto mb-[1.875em] border-[.25em] border-[#facea8] text-[#facea8] rounded-full cursor-default">
              <div className="text-[3.75rem] leading-[5rem]">!</div>
            </div>
            <div className="relative flex justify-center items-center font-bold text-[#6c757d] text-3xl text-center">
              Are you sure?
            </div>
            <div className="block text-[#6c757d] font-semibold">
              You won't be able to revert this!
            </div>
            <div className="w-full mt-3 flex items-center justify-center flex-wrap">
              <button
                type="button"
                onClick={handleSubmit}
                className="bg-primary m-1 py-2 px-8 font-medium text-[1.0625em] rounded-[0.25em] text-darkTextColor flex justify-center w-44"
              >
                {isLoading ? (
                  <CircularProgress size={24} sx={{ color: "white" }} />
                ) : (
                  "Yes, delete it!"
                )}
              </button>
              <ButtonClose onClick={() => handleClose()} />
            </div>
          </div>
        </div>
      </ContainerPop>
    </div>
  );
};

export default DeleteModal;
